import {
  params,
  arrayOf as arrayType,
  bool as boolType, number as numberType,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';

const baseProductShape = {
  itemId: stringType(),
  dataSources: stringType(),
  availabilityType: shapeType({
    discontinued: boolType(),
    status: boolType()
  }),
  details: shapeType({
    description: stringType()
  }),
  identifiers: shapeType({
    brandName: stringType(),
    canonicalUrl: stringType(),
    itemId: stringType(),
    modelNumber: stringType(),
    productLabel: stringType(),
    storeSkuNumber: stringType(),
    upcGtin13: stringType(),
    skuClassification: stringType(),
    omsThdSku: stringType()
  }),
  info: shapeType({
    returnable: stringType()
  }),
  media: shapeType({
    image: shapeType({
      url: stringType()
    }).client(),
    images: arrayType(shapeType({
      url: stringType(),
      type: stringType(),
      subType: stringType(),
      sizes: arrayType(stringType())
    })),
    video: arrayType(shapeType({
      shortDescription: stringType(),
      thumbnail: stringType(),
      url: stringType(),
      videoStill: stringType(),
      uploadDate: stringType(),
      dateModified: stringType()
    }))
  }),
  pricing: params({ storeId: stringType() }).shape({
    promotion: shapeType({
      dates: shapeType({
        end: stringType()
      })
    }),
    value: numberType({ float: true }),
    original: numberType({ float: true })
  }),
  reviews: shapeType({
    ratingsReviews: shapeType({
      averageRating: stringType(),
      totalReviews: stringType()
    })
  }),
  seo: shapeType({
    seoKeywords: stringType(),
    seoDescription: stringType()
  }),
  specificationGroup: arrayType(shapeType({
    specifications: arrayType(shapeType({
      specName: stringType(),
      specValue: stringType()
    })),
    specTitle: stringType()
  })),
  taxonomy: shapeType({
    brandLinkUrl: stringType(),
    breadCrumbs: arrayType(shapeType({
      label: stringType(),
      url: stringType()
    }))
  })
};

export const productModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    ...baseProductShape
  })
};

export const productBundleModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    ...baseProductShape,
    bundleSpecificationDetails: params({ storeId: stringType(), zipCode: stringType() }).shape({
      experienceType: stringType(),
      components: arrayType(shapeType({
        defaultProductId: stringType()
      }))
    })
  })
};

export const productsModel = {
  products: params({ itemIds: arrayType(stringType().isRequired()).isRequired() }).arrayOf({
    itemId: stringType(),
    identifiers: shapeType({
      brandName: stringType(),
      productLabel: stringType(),
      productType: stringType()
    }),
    media: shapeType({
      images: arrayType(shapeType({
        url: stringType(),
      })),
      video: arrayType({
        shortDescription: stringType(),
        thumbnail: stringType(),
        url: stringType(),
        videoStill: stringType(),
        uploadDate: stringType(),
        dateModified: stringType()
      })
    })
  })
};
